import {Link} from '@remix-run/react'

import {ThemeSwitch} from '#app/routes/resources+/theme-switch'
import {HeartIcon, LibraryBig} from '#app/ui/icons'

export function Footer() {
  return (
    <footer className="container flex items-center justify-between py-1">
      <Link
        className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-muted-foreground"
        to="/"
      >
        <LibraryBig className="h-4 w-4" />
        {ENV.APP_NAME}
      </Link>

      <p className="group flex items-center gap-1 text-xs text-muted-foreground">
        built with
        <HeartIcon className="size-4 fill-primary stroke-none transition-all duration-500 [transform-style:preserve-3d] group-hover:animate-flip" />
        by
        <a
          className="underline"
          href="https://github.com/sitek94"
          rel="noopener noreferrer"
          target="_blank"
        >
          maciek sitkowski
        </a>
      </p>
      <ThemeSwitch />
    </footer>
  )
}
